var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMainMenuBell = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00008 11.0648V7.5C5.00008 4.73858 7.23866 2.5 10.0001 2.5V2.5C12.7615 2.5 15.0001 4.73858 15.0001 7.5L15 11.0648L16.3616 12.4264C16.557 12.6217 16.6667 12.8867 16.6667 13.1629V13.5417C16.6667 14.117 16.2003 14.5833 15.625 14.5833H4.37504C3.79974 14.5833 3.33337 14.117 3.33337 13.5417V13.1629C3.33338 12.8867 3.44312 12.6217 3.63847 12.4264L5.00008 11.0648Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.8749C10.7118 17.7083 9.28824 17.7083 8.33337 16.8749",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMainMenuBell);
export default ForwardRef;